import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnBadge from "../toolbox/CgnBadge";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";

class FixedCastingList extends Component {
  state = {
    pageTitle: "Döküm Sabitleri Listele",
    pageAddLink: "dokum-sabitleri-ekle",
    pageUpdateLink: "dokum-sabitleri-guncelle",
    pageDetailLink: "dokum-sabitleri-detay",
    pageListLink: "dokum-sabitleri-listele",
    breadcrumb: [{ text: "Döküm Sabitleri", link: "#" }],
    isLoading: false,
    isDeleted: false,
    status: false,
    fixedCastingData: [],
    name: "",
    guid: "",
    alertErrorMessage: "",
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var statusType = 1; // 1 aktif ve pasiflerin ikisinide getirmesi için
    axios
      .get(URL + "/fixedCastings/getlist/" + statusType, config)
      .then((response) => {
        this.setState({
          fixedCastingData: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/fixedCastings/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  thStyle = {
    width: "130px",
  };

  thStyle2 = {
    width: "130px",
  };

  tdStyle = {
    width: "150px",
  };

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row className="canalList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <CgnDatatable
                data={this.state.fixedCastingData}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Döküm Maliyet Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>TDI Ester Birimi</th>
                              <td style={this.tdStyle}>
                                {row.tdiEsterRate}
                              </td>  
                              <th style={this.thStyle2}>MDI Ester Birimi</th>
                              <td>
                                {row.mdiEsterRate}
                              </td>                                                   
                            </tr>
                            <tr>
                              <th style={this.thStyle}>TDI Ether Birimi</th>
                              <td style={this.tdStyle}>
                                {row.tdiEtherRate}
                              </td>  
                              <th style={this.thStyle2}>MDI Ether Birimi</th>
                              <td>
                                {row.mdiEtherRate}
                              </td>                                                   
                            </tr>
                            <tr>
                            <th style={this.thStyle}>BDO Birimi</th>
                              <td style={this.tdStyle}>
                                {row.bdoRate}
                              </td>    
                              <th style={this.thStyle2}>BDO Yüzdesi</th>
                              <td>
                                {row.bdoPercent}
                              </td>    
                            </tr>
                            <tr>
                              <th style={this.thStyle2}>Moca Yüzdesi</th>
                              <td colSpan={4}>
                                {row.mocaPercent}
                              </td>    
                            </tr>
                            <tr>
                            <th style={this.thStyle2}>Ekleyen Kullanıcı</th>
                              <td colSpan={4}>
                              {row.createdBy}
                              </td> 
                            </tr>                      
                          </tbody>
                        </Table>
                      );
                    },
                  },  

                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonDropdown
                        label={"Yönet"}
                        className="mr-0"
                        color="primary"
                        items={[
                          {
                            text: CgnMessage.updateButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageUpdateLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.detailButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageDetailLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.deleteButton,
                            className: "dropDownBtn",
                            onClick: () => this.handleDelete(row.guid),
                          },
                        ]}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default FixedCastingList;
